import Logo from '../../../../shared/assets/images/png/iGuideLogo.png';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const IGuideLogo = styled.img<React.CSSProperties>`
  height: ${37 * Screen.widthRatio}px;
  width: ${194 * Screen.widthRatio}px;
  margin-bottom: ${16 * Screen.widthRatio}px;
  margin-right: ${8 * Screen.widthRatio}px;
`;

IGuideLogo.defaultProps = {
  src: Logo,
};

export default withImage(IGuideLogo);
